(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PremDiscGroupDeleteController',PremDiscGroupDeleteController);

    PremDiscGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'PremDiscGroup'];

    function PremDiscGroupDeleteController($uibModalInstance, entity, PremDiscGroup) {
        var vm = this;

        vm.premDiscGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PremDiscGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
